<div class="left-panel-content">
  <!-- Logo -->
  <div class="logo">
    <img class="image" [src]="theme?.logo">
    <div class="text">
      <div class="title">{{ theme?.product }}</div>
      <div class="subtitle">Workflow Portal</div>
    </div>
  </div>
  <!-- Projects -->
  <app-select-project></app-select-project>
  <!-- Menu -->
  <div class="menu">
    <div class="menu-list">
      @for (item of menuItems; track item.name) {
        @if (canShowMenuItem(item)) {
          <a [routerLink]="['/', projectId, item.link]" class="item" [class.selected]="item.name === selectedMenuItem" (click)="selectMenuItem(item)">{{ item.name }}</a>
        }
      }
    </div>
  </div>
  <!-- User -->
  <div class="user">
    @if (account) {
      <div class="user-info" (click)="openUserSettings()">
        <div class="photo">
          @if (account.photoUrl?.length) {
            <img class="image" [src]="account.photoUrl">
          }
        </div>
        <div class="info">
          @if (account.name?.length) {
            <div class="name">{{ account.name }}</div>
          }
          <div class="email">{{ account.email }}</div>
        </div>
      </div>
    }
    <div class="button" (click)="logout()">Logout</div>
  </div>
</div>